import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-28 lg:pt-36 pb-16 lg:pb-24 leaf-bg overflow-hidden"
    >
      <div className="container-wide relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7 fade-in-up">
            <div
              data-testid="hero-eyebrow"
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary text-secondary-foreground text-xs font-semibold tracking-wide"
            >
              <Sparkles className="h-3.5 w-3.5" />
              SUSTAINABILITY • DE-CARBONISATION • NET ZERO
            </div>

            <h1
              data-testid="hero-title"
              className="mt-5 font-display font-black text-foreground text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
            >
              Energy Transition,
              <span className="block text-primary">Sustainability &</span>
              De‑Carbonisation Solutions
            </h1>

            <p
              data-testid="hero-subtitle"
              className="mt-6 text-base sm:text-lg text-muted-foreground max-w-2xl leading-relaxed"
            >
              Green Earth Energy Solutions (GEES) contributes to the
              development of sustainable green energy projects and the
              transition from conventional to carbon‑neutral processes — helping
              clients achieve their net carbon zero targets.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Button
                asChild
                data-testid="hero-cta-primary"
                size="lg"
                className="bg-primary hover:bg-primary/90 rounded-full px-6 h-12"
              >
                <a href="#contact" className="inline-flex items-center gap-2">
                  Start an Enquiry <ArrowRight className="h-4 w-4" />
                </a>
              </Button>
              <Button
                asChild
                data-testid="hero-cta-secondary"
                size="lg"
                variant="outline"
                className="rounded-full px-6 h-12 border-primary/30 text-primary hover:bg-primary/5"
              >
                <a href="#sectors">Explore Our Sectors</a>
              </Button>
            </div>

            <dl className="mt-12 grid grid-cols-3 gap-6 max-w-xl">
              {[
                { k: "25+", v: "Years industry experience" },
                { k: "3", v: "Sector verticals served" },
                { k: "Net Zero", v: "Mission-aligned delivery" },
              ].map((s) => (
                <div key={s.v} data-testid={`hero-stat-${s.k}`}>
                  <dt className="font-display text-2xl lg:text-3xl font-bold text-primary">
                    {s.k}
                  </dt>
                  <dd className="text-xs lg:text-sm text-muted-foreground mt-1">
                    {s.v}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5 relative fade-in-up" style={{ animationDelay: "120ms" }}>
            <div className="relative rounded-2xl overflow-hidden border border-border shadow-2xl shadow-primary/10">
              <img
                src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=1200&q=80"
                alt="Wind turbines on a green landscape representing renewable energy"
                className="w-full h-[420px] lg:h-[520px] object-cover"
                data-testid="hero-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur rounded-xl p-4 border border-border">
                <p className="text-xs font-semibold uppercase tracking-wider text-primary">
                  One‑Stop Solutions
                </p>
                <p className="mt-1 text-sm text-foreground font-medium leading-snug">
                  Feasibility • Technology Evaluation • FEED • EPCM • BOOT
                </p>
              </div>
            </div>
            <div className="absolute -top-6 -right-6 h-32 w-32 rounded-full bg-accent/30 blur-2xl -z-10" />
            <div className="absolute -bottom-8 -left-8 h-40 w-40 rounded-full bg-primary/20 blur-3xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
}
